import classNames from "classnames";
import { GoBack } from "../controls/goback";
import { Header } from "../header";
import { SideMenu } from "../side_menu";
import "./commonLayout.scss";

export interface CommonLayoutProps {
    children: React.ReactChild;
    hideSideMenu?: boolean;
    showBackBtnTop?: boolean;
    showBackBtnSide?: boolean;
}

export const CommonLayout = ({children, ...props}: CommonLayoutProps) => (
    <>
      <Header />
      
      <div className="page-layout">
        <aside className="page-aside-content">
          {!props.hideSideMenu && <SideMenu />}
        </aside>
        
        <section className={classNames(
            "page-section-content", {"-horizontal": props.showBackBtnTop}
        )}>
            {(props.showBackBtnSide || props.showBackBtnTop) && 
            <div className="goback">
                <GoBack />
            </div>
            }
            <div className="content">
                {children}
            </div>
            <div className="padding"/>
        </section>
      </div>
    </>  
)